import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHtml5,
  faCss3Alt,
  faJs,
  faReact,
  faGitAlt,
  faGithub,
  faNodeJs,
  faBootstrap,
} from "@fortawesome/free-brands-svg-icons";

export default function AboutPage() {
  return (
    <div>
      <Container className="py-5 aboutStyle">
        
        {/* About Me Section */}
        <Row className="align-items-center mb-5">
          <Col md={6}>
            <h2>👨‍💻 Who I Am</h2>
            <p className="mt-4 lead">
              👋 Hi! I'm a passionate <b>Junior Web Developer</b> with a strong foundation in IT support and 
              growing expertise in <b>full-stack development</b>. I recently completed an immersive 
              Software Engineering Bootcamp, where I built responsive, user-friendly web applications 
              using <b>HTML5</b>, <b>CSS3</b>, <b>JavaScript (ES6+)</b>, <b>React</b>, <b>Node.js</b>, and <b>MySQL</b>.
            </p>
            <p>
              My journey began in <b>technical support</b>, where I discovered a love for solving problems 
              and building reliable digital systems. Now, I blend <b>precision</b> with <b>creativity</b> to craft 
              intuitive web experiences.
            </p>
          </Col>

          <Col md={6} className="mt-4 mt-md-0">
            <h2>🎯 Core Strengths</h2>
            <ul className="list-unstyled mt-3">
              <li>✅ Detail-oriented problem solver</li>
              <li>✅ Strong communicator & collaborator</li>
              <li>✅ Experience with Agile methodology</li>
              <li>✅ Commitment to clean, scalable code</li>
              <li>✅ Lifelong learner driven by curiosity</li>
            </ul>
          </Col>
        </Row>

        {/* Skills Section */}
        <Row className="mb-4">
          <Col className="text-center">
            <h3>⚡ Skills & Tech Stack</h3>
            <p className="">Here are the tools and technologies I work with:</p>
          </Col>
        </Row>

        <Row>
          {/* Languages */}
          <Col md={4} className="mt-4">
            <Card className="h-100 shadow-sm">
              <Card.Body>
                <Card.Title className="mb-3">Programming Languages</Card.Title>
                <ul className="list-unstyled">
                  <li><FontAwesomeIcon icon={faHtml5} color="#f16529" /> HTML5</li>
                  <li><FontAwesomeIcon icon={faCss3Alt} color="#2965f1" /> CSS3</li>
                  <li><FontAwesomeIcon icon={faJs} color="#f0db4f" /> JavaScript (ES6+)</li>
                </ul>
              </Card.Body>
            </Card>
          </Col>

          {/* Frameworks */}
          <Col md={4} className="mt-4">
            <Card className="h-100 shadow-sm">
              <Card.Body>
                <Card.Title className="mb-3">Frameworks</Card.Title>
                <ul className="list-unstyled">
                  <li><FontAwesomeIcon icon={faReact} color="#61dafb" /> React</li>
                  <li><FontAwesomeIcon icon={faNodeJs} color="#8CC84B" /> Node.js</li>
                  <li><FontAwesomeIcon icon={faBootstrap} color="#563d7c" /> Bootstrap</li>
                </ul>
              </Card.Body>
            </Card>
          </Col>

          {/* Tools & DB */}
          <Col md={4} className="mt-4">
            <Card className="h-100 shadow-sm">
              <Card.Body>
                <Card.Title className="mb-3">Tools & Databases</Card.Title>
                <ul className="list-unstyled">
                  <li><FontAwesomeIcon icon={faGitAlt} color="#f1502f" /> Git</li>
                  <li><FontAwesomeIcon icon={faGithub} color="#181717" /> GitHub</li>
                  <li><FontAwesomeIcon color="#00618a" /> MySQL</li>
                  <li><FontAwesomeIcon  color="#007acc" /> VS Code</li>
                </ul>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}